import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router';
import ImageCircularAvatar from '@/components/UI/Avatar/ImageCircularAvatar';
import ReactSelect from '@/components/UI/Form/ReactSelect';
import { getInitials } from '@/utils';

type ReportSettings = {
  generatedBy: string;
  notes: string;
  createdAt: string;
  lastGeneratedAt: string;
  updatedAt: string;
};

type Receipent = {
  name: string;
  email: string;
  title: string;
  status: string;
  role: string;
};

const settingsColumnHelper = createColumnHelper<ReportSettings>();
const receipentsColumnHelper = createColumnHelper<Receipent>();

export const settingsColumns = [
  settingsColumnHelper.accessor('generatedBy', {
    header: 'Generated By',
    size: 150,
  }),
  settingsColumnHelper.accessor('createdAt', {
    header: 'Date Created',
    size: 100,
  }),
  settingsColumnHelper.accessor('lastGeneratedAt', {
    header: 'Last Generated',
    size: 120,
  }),
  settingsColumnHelper.accessor('updatedAt', {
    header: 'Last Updated',
    size: 100,
  }),
  settingsColumnHelper.accessor('notes', {
    header: 'Notes',
    size: 200,
  }),
  settingsColumnHelper.display({
    header: 'Report Receiving',
    size: 150,
    cell: ({ row }) => (
      <div>
        <label className='text-sm text-gray-500'>
          Period
          <ReactSelect
            defaultValue={{
              label: 'Last week',
              value: 'LAST_WEEK',
            }}
            options={[
              { label: 'Last week', value: 'LAST_WEEK' },
              { label: 'Last month', value: 'LAST_MONTH' },
            ]}
          />
        </label>
        <div className='my-4'></div>
        <label className='text-sm text-gray-500'>
          Frequency
          <ReactSelect
            defaultValue={{ label: 'Daily', value: 'DAILY' }}
            options={[
              { label: 'Daily', value: 'DAILY' },
              { label: 'Weekly', value: 'WEEKLY' },
            ]}
          />
        </label>
      </div>
    ),
  }),
];

export const listOfReceipentsColumns = [
  receipentsColumnHelper.accessor('name', {
    header: 'Name',
    size: 150,
    cell: ({ cell, row }) => {
      return (
        <Link to={`/app/administration/users/${cell.getValue()}`}>
          <div className='flex items-center gap-2'>
            <ImageCircularAvatar imageUrl={''} fallbackText={getInitials(cell.getValue())} />
            <div>
              <p>{cell.getValue()}</p>
              <p className='text-xs text-gray-400'>{row.original.email}</p>
            </div>
          </div>
        </Link>
      );
    },
  }),
  receipentsColumnHelper.accessor('title', {
    header: 'Title',
    size: 300,
  }),
  receipentsColumnHelper.accessor('status', {
    header: 'Status',
    size: 170,
  }),
  receipentsColumnHelper.accessor('role', {
    header: 'Role',
    size: 170,
  }),
];
